import { render, staticRenderFns } from "./rounds.vue?vue&type=template&id=0e66a29a&"
import script from "./rounds.vue?vue&type=script&lang=js&"
export * from "./rounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports